export const importedPageRoute = (name: string): string => {
  if (name === "index") return "";
  if (name === "careers") return "jobs";
  if (name === "model-evaluation") return "argusrl";
  return name;
};

export function resolveImportedLink(href: string, locale: string): string {
  if (href === "https://api.trustscale.ai/" || href === "https://api.trustscale.ai") {
    return "https://api.trustscale.ai/documentation";
  }
  const match = href.match(/^(?:\.\/|\/)?([a-z0-9-]+)\.html(.*)$/i);
  if (match) {
    const route = importedPageRoute(match[1]);
    return `/${locale}${route ? `/${route}` : ""}${match[2]}`;
  }
  if (href.startsWith("/en")) return href.replace(/^\/en(?=\/|$)/, `/${locale}`);
  return href;
}